import styled from 'styled-components';

export const LoginContainer = styled.div`
  height: 100vh;
  width: 100vw;

  display: flex;
  justify-content: center;
  align-items: center;

  background-color: ${props => props.theme.palette.background};
`;

export const LoginButtonContainer = styled.article`
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 4rem;

  background-color: ${props => props.theme.palette.common.white};
  border-radius: ${props => props.theme.borderRadius.large};
`;

export const LoginTitle = styled.h1`
  font-size: 2rem;
  font-weight: 600;
`;

export const LoginDescription = styled.h2`
  font-size: 1.4rem;
  color: ${props => props.theme.font.color.description};

  margin-bottom: 4rem;
`;
